import React, { Component, PropTypes } from 'react';
import { RaisedButton, Styles, TextField } from 'material-ui';
import Spinner from 'components/Material/Spinner';
import CoursioLogo from 'components/CoursioLogo';
import Message from 'services/Message';
import * as Colors from 'components/Material/Styles/Colors';

let { Spacing } = Styles;

export default class ForgotPasswordForm extends Component {
  state = {
    displayName: localStorage && localStorage.displayName
  };

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    getIntlMessage: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  resetLogin() {
    this.setState({ displayName: null });
  }

  loginWithGoogle() {}

  submit(e) {
    let email = this.refs.email.getValue();
    e.preventDefault();

    if (!email) {
      Message.info('Please provide credentials.');
      return;
    }
    if (this.props.onSubmit) {
      this.props.onSubmit(email);
    }
  }

  render() {
    let button;
    if (this.state.loading) {
      button = (
        <RaisedButton fullWidth={true} secondary={true} disabled={true}>
          <Spinner />
        </RaisedButton>
      );
    } else {
      button = (
        <RaisedButton
          fullWidth={true}
          label={this.context.getIntlMessage('Request')}
          secondary={true}
          onTouchTap={this.submit.bind(this)}
        />
      );
    }

    return (
      <div className="login">
        <form onSubmit={this.submit.bind(this)}>
          <div style={{ textAlign: 'center' }}>
            <CoursioLogo initialFill="#09BEC3" />
            <h1
              style={{
                fontSize: '1.5em',
                color: Colors.Colors.grey[500].material,
                padding: Spacing.desktopGutterMini * 2
              }}
            >
              {this.context.getIntlMessage('forgotPassword')}
            </h1>
          </div>
          <TextField
            fullWidth={true}
            onEnterKeyDown={this.submit.bind(this)}
            hintText={this.context.getIntlMessage('Email')}
            floatingLabelText={this.context.getIntlMessage('Email')}
            ref="email"
            type="text"
          />
          {button}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ForgotPasswordForm.js